import styled from 'styled-components';
import ColorsHelper from '../../../../../core/helpers/ColorsHelper';

const SelectElement = styled.div`
  width: 100%;
  > div {
    width: 100%;
  }
`;
const SelectWrapper = styled.div.attrs((props: any) => ({
  isEmpty: props.isEmpty,
  disabled: props.disabled
}))`
  width: 100%;
  height: 40px;
  overflow: visible;
  position: relative;
  outline: 1px solid
    ${(props) => (props.disabled ? '#D5E5F0' : 'var(--neutrals-neutral02)')};
  border-radius: 0.4rem;
  pointer-events: ${(props) => (props.disabled ? 'none' : 'auto')};

  &&:focus {
    border: 0px solid #4318cd;
    outline: 1px solid #4318cd;
    border-radius: 0.4rem;
  }
  > div {
    cursor: default;
  }

  .menu {
    position: relative;
    display: none;
    width: inherit;
  }
  .menu.active {
    display: block;
    width: inherit;
  }
  .selected {
    /* padding: 10px 8px 10px 18px; */
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
    border-radius: 4px;
    /* border: 1px solid var(--text-text01); */
    /* outline: 1px solid var(--text-text01); */
    min-width: 153px;
    width: auto;
    justify-content: space-between;
    font-size: 1.4rem;
    font-weight: bold;
    color: var(--neutral-03);
    position: relative;
  }
  .selected:hover {
    /* border: 1px solid var(--text-primary); */
  }

  /* .selected:focus {
    border: 1px solid ${ColorsHelper.getColor('#fc4a61')};
  } */

  .selected > *:focus {
    background-color: red;
  }

  .menu-container {
    min-width: 153px;
    width: inherit;
    color: black;
    list-style: none;
    padding: 4px 0px;
    max-height: 208px;
    overflow-x: hidden;
    overflow-y: auto;
    background-color: #fff;
    color: var(--neutral-03);
    margin-top: 0.8rem;
    border-radius: 0.4rem;
    border-width: 0;
    -webkit-box-shadow: 0 4px 16px -8px #b0c0ca;
    box-shadow: 0 4px 16px -8px #b0c0ca;
    -webkit-overflow-scrolling: touch;
    will-change: scroll-position;
    z-index: 1;
    position: absolute;
  }

  .menu-container::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgb(0 0 0 / 0%);
    -webkit-box-shadow: inset 0 0 6px rgb(0 0 0 / 0%);
    border-radius: 10px;
    background-color: rgb(255 255 255 / 70%);
  }
  .menu-container::-webkit-scrollbar-thumb {
    background-color: #b0c0ca;
    border-radius: 10px;
  }

  .menu-container::-webkit-scrollbar {
    width: 6px;
    background-color: #f5f5f5;
  }

  .item {
    position: relative;
    font-size: 14px;
    font-weight: normal;
    margin: 0;
    color: #161d1f;
    background-color: #fff;
  }
  .item.active {
    background-color: #e2dffd;
    /* color: var(--text-text01); */
    /* font-weight: bold; */
  }
  .item:hover {
    background-color: #d5e5f0;
    color: #161d1f;
    /* font-weight: normal; */
  }

  .item:focus {
    background-color: #a8cbe2;
    color: #161d1f;
    /* font-weight: normal; */
  }

  .item:active {
    background-color: #a8cbe2;
    color: #161d1f;
    /* font-weight: normal; */
  }

  .selected:focus {
    border: 0px solid #4318cd;
    outline: 1px solid #4318cd;
    /* outline-offset: -4px; */
  }
  /* option:hover {
    background: limegreen;
  }

  option:focus {
    background: red;
  } */
  .button-toggle {
    position: absolute;
    top: 8px;
    right: 8px;
  }

  .item .item-link {
    display: inline-block;
    border: none;
    margin: 0;
    text-decoration: none;
    cursor: default;
    text-align: left;
    -webkit-appearance: none;
    -moz-appearance: none;
    outline: 0px solid #fff;
    outline-offset: -4px;
    padding: 0;
    width: 100%;
    padding: 10px 16px;
  }

  .item .item-link:focus {
    outline: 0px solid #fff;
    outline-offset: -4px;
  }

  cc-icon {
    border-width: 0;
    -ms-flex-order: 3;
    order: 3;
    color: var(--text-primary);
    display: flex;
  }

  cc-icon.calendar {
    border-width: 0;
    -ms-flex-order: 1;
    order: 1;
    color: var(--neutral-03);
    display: flex;
  }

  label {
    display: flex;
    -ms-flex-order: 2;
    order: 2;
  }
`;

const LabelSelect = styled.p`
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  width: 88%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: ${(props) => props.color};
`;

export { SelectElement, SelectWrapper, LabelSelect };
